import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrame } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrame(myframe)
  .then((api) => {
    LwAPI = api;
    clearOutput();
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

var errHndId = 0;
var readyListenerId = -1;

function ex_register() {
  LwAPI?.registerOnError(errorHandler).then(function (arg: number) {
    errHndId = arg;
    appendToOutput("Error handler registered with ID " + errHndId);
  });
}

function ex_unregister() {
  if (errHndId === null) {
    appendToOutput("No error handler available to unregister");
  } else {
    LwAPI?.unregisterOnError(errHndId);
    appendToOutput(
      "Error handler with ID " + errHndId + " has been unregistered"
    );
  }
}

function errorHandler(arg: any) {
  var errType = "";
  switch (arg.error) {
    case 0:
      errType = "UNKNOWN";
      break;
    case 1:
      errType = "OPENMODEL";
      break;
    case 2:
      errType = "WEBSOCKET";
      break;
    case 3:
      errType = "VIEWER";
      break;
  }
  appendToOutput(
    "ERROR CODE: " +
      arg.error +
      "\nERROR TYPE: " +
      errType +
      "\nERROR MESSAGE:\n" +
      arg.text
  );
}

function simluateFileOpenError() {
  clearOutput();
  appendToOutput("Try opening a model that does not exist");
  LwAPI?.openModel("fictional/path/does/not/exist.jt");
}

function simulateViewerError() {
  clearOutput();
  // To provoke the viewer error, no model must be open.
  // To make sure no model is open, open a known model and close it again.
  LwAPI?.registerOnReady(simulateViewerErrorOnReady).then(function (
    listenerId
  ) {
    readyListenerId = listenerId;
    appendToOutput("Open a model ...");
    return LwAPI?.openModel("Flange.jt");
    // Demo continues in simulateViewerErrorOnReady(), the ready listener callback function
  });
}

function simulateViewerErrorOnReady() {
  LwAPI?.unregisterOnReady(readyListenerId)
    .then(function () {
      appendToOutput("Close the model ... ");
      return LwAPI?.closeModel("Flange.jt");
    })
    .then(function () {
      // Because no model is open, the following command will cause a VIEWER error.
      appendToOutput("Try adding a comment while no model is open ...");
      return LwAPI?.addComment("Comment 2001", { x: 400, y: 300, z: 82 });
    });
}

function appendToOutput(msg: any) {
  (document.getElementById("output") as HTMLTextAreaElement).value =
    (document.getElementById("output") as HTMLTextAreaElement).value +
    "\n-----\n" +
    msg;
}

function clearOutput() {
  (document.getElementById("output") as HTMLTextAreaElement).value = "";
}

// Bind functions to buttons
document.getElementById("register")?.addEventListener("click", async () => {
  await apiReady;
  ex_register();
});
document.getElementById("unregister")?.addEventListener("click", async () => {
  await apiReady;
  ex_unregister();
});
document.getElementById("openerr")?.addEventListener("click", async () => {
  await apiReady;
  simluateFileOpenError();
});
document.getElementById("viewererr")?.addEventListener("click", async () => {
  await apiReady;
  simulateViewerError();
});
